export const AUTH_ERROR_EVENT = "AUTH_ERROR_EVENT"